import { httpClient } from '../../../services/http/httpClient.js';
import { buildQueryString, getCollection } from '../../../services/teams/serviceUtils.js';

const TEAM_DISABLE_API_URL = '/api/teamdisable';

export const teamDisableService = {
  getDisables: async (filters = {}) => {
    const hasFilters = filters.teamId || filters.date;
    const queryString = buildQueryString(filters);
    const url = hasFilters
      ? `${TEAM_DISABLE_API_URL}/filter${queryString ? `?${queryString}` : ''}`
      : `${TEAM_DISABLE_API_URL}${queryString ? `?${queryString}` : ''}`;

    const payload = await httpClient.get(url);
    return {
      disables: getCollection(payload, ['teamDisables', 'disables']),
      pagination: payload?.pagination || null,
      payload
    };
  },

  createDisable: async (payload) => {
    return httpClient.post(TEAM_DISABLE_API_URL, { data: payload });
  },

  deleteDisable: async ({ teamId, date }) => {
    const queryString = buildQueryString({ teamId, date });
    const url = queryString ? `${TEAM_DISABLE_API_URL}?${queryString}` : TEAM_DISABLE_API_URL;
    return httpClient.delete(url);
  }
};
